/**
 * Link PHỤ của một tin (26/10/2026): chuông "Khách đang rất bực" bấm vào vẫn mở
 * khung chat, còn link này mở Sổ khiếu nại trên Cổng dịch vụ ở tab mới. Dùng
 * chung cho chuông và trang "Thông báo của tôi".
 *
 * Đặt CẠNH nút mở tin, không lồng vào trong: thẻ <a> nằm trong <button> là HTML
 * sai, và bấm link sẽ kéo theo cả việc mở tin.
 */

import { ExternalLink } from "lucide-react";
import type { StaffNotification } from "./api";
import { portalTarget } from "./open-notification";

export function NotificationExtraLink({
  n,
  className = "",
}: {
  n: Pick<StaffNotification, "extraLink" | "extraLinkLabel">;
  className?: string;
}) {
  // Chỉ mở ra ngoài khi đúng gốc Cổng — cùng rào với lúc bấm tin.
  const href = portalTarget(n.extraLink);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-xs text-primary underline-offset-2 hover:underline ${className}`}
    >
      <ExternalLink className="h-3 w-3 shrink-0" aria-hidden />
      {n.extraLinkLabel || "Mở trên Cổng"}
    </a>
  );
}
